import React from 'react';
import { Button, Form } from 'antd';
import { ExclamationCircleFilled, MailOutlined } from '@ant-design/icons';
import { useOrderContext } from '../../../View/context';
import { useOrderContextForm } from '../../context';
import { DeliveryService, OrderStatus } from '../../../Adapter/enums';
import { useSimpleModal } from '../../../../../Common/Modal/Simple';
import restrictionList from '../../../../../../utils/dhlShipment/dhl_control.json';
import { isDhlService } from '../../../../../../utils/deliveryServices';

type OnClickType = (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;

// helper → check if country requires Proforma invoice
const requiresProforma = (countryCode: string): boolean => {
  if (!countryCode) return false;
  const item = restrictionList.find(
    (entry: any) => entry.countryCode === countryCode
      && entry.requiresProforma?.toUpperCase() === 'Y',
  );

  console.log('Is proforma required:', countryCode, item);

  return !!item;
};

interface CreateShipmentButton {
  onClick?: OnClickType; // React.MouseEventHandler<HTMLElement>
  loading?: boolean;
  disabled?: boolean;
}

function CreateShipmentButton({ onClick, loading, disabled }: CreateShipmentButton) {
  const { open, contextHolder } = useSimpleModal();
  const { clientOrderData } = useOrderContext();
  const {
    deliveryForm, documentsForm, shipperForm, consigneeForm,
  } = useOrderContextForm();

  const handleClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();

    const deliveryService = deliveryForm.getFieldValue('deliveryService');
    const shipperCountry = shipperForm.getFieldValue('countryCode');
    const consigneeCountry = consigneeForm.getFieldValue('countryCode');
    const proforma = documentsForm.getFieldValue('proformaInvoices');
    const hasProforma = !!proforma?.fileList?.length;

    const needsInvoice = requiresProforma(shipperCountry) || requiresProforma(consigneeCountry);

    if (isDhlService(deliveryService?.toLowerCase()) && (needsInvoice && !hasProforma)) {
      open({
        icon: <ExclamationCircleFilled />,
        title: 'Proforma Invoice Required',
        content: (
          <span>
            Before shipping goods, please generate or upload the Proforma Invoice
            to ensure smooth processing and avoid shipment delays.
          </span>
        ),
        okText: 'Continue without proforma',
        cancelText: 'Cancel',
        onOk: () => {
          onClick?.(e);
        },
      });
    } else {
      onClick?.(e);
    }
  };

  if (clientOrderData?.status && [
    OrderStatus.PROCESSING,
    OrderStatus.EXPIRED,
    OrderStatus.SHIPPED_OUT,
    OrderStatus.ON_THE_WAY,
    OrderStatus.DELIVERED,
    OrderStatus.DECLINED,
    OrderStatus.TO_BE_PAID,
  ].includes(clientOrderData?.status)) {
    return null;
  }

  return (
    <>
      {contextHolder}
      <Button
        icon={<MailOutlined />}
        disabled={disabled}
        loading={loading}
        type="primary"
        onClick={handleClick}
      >
        Create shipment
      </Button>
    </>
  );
}

export default CreateShipmentButton;
